/**
 * @file 使用form的形式提交数据
 * @author ss
 */

import axios from 'axios';
import qs from 'qs';


import baseURL from './config';

const Ax = axios.create({
  baseURL,
  timeout: 1024000,
  withCredentials: true,
});

Ax.interceptors.response.use(response => response, (error) => {
  const response = error.response;
  if (response.status === 401) {
    return Promise.reject('login failed');
  }
  return Promise.reject(error);
});

const myPromise = {
  then() {
    return myPromise;
  },
  catch() {
    return myPromise;
  },
};

const Request = {
  form(url, data = {}, config) {
    return new Promise((resolve, reject) => {
      Ax({
        url,
        method: 'post',
        data: qs.stringify(data),
        ...config,
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        const msg = err.message || '接口错误';
        reject(msg);
      });
    });
  },
};

export default Request;



// WEBPACK FOOTER //
// ./src/utils/Request/form.js